
import { Vue, Component, Prop } from "vue-property-decorator";
// import { areaList } from "@/api/common";
@Component({
  name: "HomeTestDia",
  components: {},
})
export default class HomeTestDia extends Vue {
  title = "立即自测";
  width = "586px";
  open = false;

  created() {}

  show(data: any) {
    this.open = true;
  }
  close() {
    this.open = false;
  }

  async getAreaList() {
    let areaCode = this.$route.query.areaCode
      ? String(this.$route.query.areaCode).substring(0, 6)
      : "";
    const res: any = await areaList(areaCode)
      .then((res: any) => {
        const { code, result, msg } = res.data;
        if (code === 200 && result) {
          return (
            result.map(({ name, id }: any) => {
              return {
                value: id,
                label: name,
              };
            }) || []
          );
        }
        return result || [];
      })
      .catch((e: string) => console.error(e));
    return res;
  }
}
